/**
 * util function for preventing propagation of an event handler
 *
 * @example
 * // with a simple () => void style click handler
 * onClick={eventStopPropagation(handleClick)}
 * // with a click handler that requires input
 * onClick={eventStopPropagation(() => handleId(id))}
 *
 */ const eventStopPropagation = (eventHandler)=>(e)=>{
        e.stopPropagation();
        e.preventDefault();
        eventHandler();
    };

export { eventStopPropagation };
